import template from './dashboard-card-profile-completion.component.html';
import controller from './dashboard-card-profile-completion.controller';

const dashboardCardProfileCompletion = {
  template,
  controller,
};

export default dashboardCardProfileCompletion;
